import React, { ReactElement } from 'react';
import { QuestionOutlined } from '@severalnines/frontend_hub/libs/icons';
import CcxComponentProps from '../../../core/CcxComponent';
import styles from './CurrentBalance.module.less';
import PrettyNumber from '../../ccx/common/PrettyNumber';

interface Props extends CcxComponentProps {
    currentBalance: number;
    suffix?: string;
}

function CurrentBalance({
    testId = 'CurrentBalance',
    currentBalance = 0,
    suffix,
}: Props): ReactElement {
    return (
        <div className={styles.CurrentBalance} data-testid={testId}>
            <div data-testid={`${testId}Top`}>
                Current balance&nbsp;
                <QuestionOutlined />
            </div>
            <div data-testid={`${testId}Middle`}>
                <strong>
                    <PrettyNumber
                        precision={2}
                        sufix={suffix}
                        value={currentBalance}
                    />
                </strong>
            </div>
        </div>
    );
}

export default CurrentBalance;
